import {ToastNotification} from '@carbon/react';
import {useDispatch} from "react-redux";
import {removeNotification, updateNotification} from "../../features/application/applicationSlice";
import {memo, useCallback} from "react";

const Index = memo((props) => {
    const notification = props.notification;
    const dispatch = useDispatch()
    const {persistent = false} = props; // New prop to control auto-close
    
    const closeNotification = useCallback(() => {
        if (notification.viewed) {
            dispatch(removeNotification(notification))
        } else {
            const nt = {...notification}
            nt.viewed = true
            dispatch(updateNotification(nt))
        }
    }, [notification, dispatch]);
    
    return (
        <ToastNotification
            subtitle={notification.subtitle}
            timeout={persistent ? 0 : notification.timeout} // 0 = no timeout when persistent
            title={notification.title}
            kind={notification.kind}
            onCloseButtonClick={closeNotification}
            caption={notification.caption}
        />
    )
})

export default Index
